import { FC } from 'react'
import { LabelGroupProps } from './types'
import { Label } from './Label'

export const LabelGroup: FC<LabelGroupProps> = ({
  labels,
  truncateAfter,
  ...globalLabelProps
}) => (
  <div className="flex gap-x-1.5 items-center">
    {labels
      .filter(
        (_, i) =>
          typeof truncateAfter !== 'number' ||
          (typeof truncateAfter === 'number' && i < truncateAfter),
      )
      .map((labelProps, i) => (
        <Label
          key={`label-group-label-${labelProps.label}-${i}`}
          {...labelProps}
          {...globalLabelProps}
        />
      ))}
    {typeof truncateAfter === 'number' && labels.length > truncateAfter && (
      <span
        title={labels
          .slice(truncateAfter)
          .map(({ label }) => label)
          .join(', ')}
        className="contents"
      >
        <Label
          label={`+${labels.length - truncateAfter}`}
          {...globalLabelProps}
          color="neutral"
          outlined={false}
        />
      </span>
    )}
  </div>
)
